export default {
	en: {
		translation: {
			queue: {

				title: "Upload Queue",
				title_uploading_with_counter: "Uploading {{num}} Assets",
				title_uploading: "Uploading Assets",
				mini_title: "Uploaded",
				mini_title_uploading: "Uploading",
				show_completed: "Show completed",
				retry_failed: "Retry failed",
				abort_all: "Abort all",
				upload_more: "Upload more",
				done: "Done",

				mini_upload_count: "{{num}} uploaded",
				mini_failed: "{{num}} failed",

				statuses: {
					uploading: "Uploading...",
					error: "Error",
					uploaded: "Done",
					aborted: "Aborted",
				},
			},
		},
	},
};
